'use client';

import { PrivyProvider } from '@privy-io/react-auth';

export default function PrivyProviderWrapper({ children }: { children: React.ReactNode }) {
  const appId = "cmitztpld03ccjq0bzmnmyth6";
  
  if (!appId) {
    console.warn('NEXT_PUBLIC_PRIVY_APP_ID is not set. Privy wallet features will not work.');
    return <>{children}</>;
  }

  return (
    <PrivyProvider
      appId={appId}
      config={{
        // Create embedded wallets for users who don't have a wallet
        embeddedWallets: {
          ethereum: {
            createOnLogin: 'all-users'
          }
        },
        // Appearance customization
        appearance: {
          theme: 'dark',
          accentColor: '#0B71FF', // Match your main color
          logo: '/assets/logo-300x300.png',
        },
        // Login methods
        loginMethods: ['email',"wallet"],
        // Legal
        legal: {
          termsAndConditionsUrl: 'https://docs.xox.exchange/about/terms-of-use',
          privacyPolicyUrl: 'https://docs.xox.exchange/about/privacy-policy',
        },
      }}
    >
      {children}
    </PrivyProvider>
  );
}

